export default () => ({

    open: false,
    query: ""
    
});